<div class="col px-5 cbb-map-form__page-col">
  <div class="cbb-map-form__layout">
    <div class="cbb-map-form__card">
      <google-map
          [height]="'420px'"
          [width]="'100%'"
          [center]="center"
          [zoom]="zoom"
          [options]="mapOptions">
          <map-marker
            [position]="{ lat: lat, lng: lng }"
            [options]="{ draggable: false }">
          </map-marker>

          <map-marker
            *ngIf="blueMarkerVisible && accessPoint"
            [position]="{ lat: accessPoint.lat, lng: accessPoint.lng }"
            [options]="{
              draggable: true,
              icon: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png'
            }"
            (mapDragend)="onAccessPointMarkerDragEnd($event)">
          </map-marker>
        </google-map>
    </div>

    <div class="cbb-map-form__card" [formGroup]="form">
        <h2 class="cbb-map-form__title">Ingresa la dirección de despacho</h2>
        <p class="cbb-map-form__hint">
          Usamos esta información para verificar cobertura. Si tu región o comuna no aparece en el
          listado, por el momento no contamos con despacho en esa zona.
        </p>

        <div class="d-flex gap-2 cbb-map-form__field">
          <div class="cbb-map-form__col cbb-map-form__select-wrapper">
            <select class="cbb-map-form__control" formControlName="region">
              <option value="" selected disabled>Región</option>
              <option
                value="{{ item.nombreRegion }}"
                *ngFor="let item of regionesComunas">
                {{ item.nombreRegion }}
              </option>
            </select>
            <p class="text-danger small mb-0 mt-1" *ngIf="showDispatchFieldError('region')">
              Debe seleccionar una región.
            </p>
          </div>
          <div class="cbb-map-form__col cbb-map-form__select-wrapper">
            <select class="cbb-map-form__control" formControlName="comuna">
              <option value="" selected disabled>Comuna</option>
              <option value="{{ item }}" *ngFor="let item of comunaByRegion">
                {{ item }}
              </option>
            </select>
            <p class="text-danger small mb-0 mt-1" *ngIf="showDispatchFieldError('comuna')">
              Debe seleccionar una comuna.
            </p>
          </div>
        </div>

        <div class="d-flex gap-2 cbb-map-form__field">
          <div class="cbb-map-form__col">
            <input
              class="cbb-map-form__control"
              type="text"
              placeholder="Calle"
              formControlName="street" />
            <p class="text-danger small mb-0 mt-1" *ngIf="showDispatchFieldError('street')">
              Debe ingresar la calle.
            </p>
          </div>
          <div class="cbb-map-form__col">
            <input
              class="cbb-map-form__control"
              type="text"
              placeholder="Número"
              formControlName="number" />
            <p class="text-danger small mb-0 mt-1" *ngIf="showDispatchFieldError('number')">
              Debe ingresar el número.
            </p>
          </div>
        </div>

        <p class="text-danger mb-1" *ngIf="form.hasError('noValid')">
          No pudimos validar la dirección. Revise los datos e inténtelo nuevamente.
        </p>

        <button
          *ngIf="!enabledSave"
          class="cbb-map-form__btn-verify"
          (click)="verificarDireccion()">
          Verificar Dirección
        </button>

        <div *ngIf="blueMarkerVisible && accessPoint" class="mt-4">
          <h2 class="cbb-map-form__title mb-0">Punto de Acceso</h2>
          <p
            class="mb-1"
            [ngClass]="{ 'text-danger fw-bold': !optional, 'text-muted': optional }">
            ({{
              optional
                ? 'Opcional'
                : 'Dirección no encontrada, por favor, mueva el pin a la dirección que desea la descarga o despacho de su pedido'
            }})
          </p>
          <p class="mt-1">Arrastre el pin azul en el mapa para indicar el punto de acceso a la obra:</p>

          <div class="cbb-map-form__field">
            <input
              class="cbb-map-form__control disable"
              placeholder="Dirección"
              type="text"
              [value]="accessPoint.address"
              readonly />
          </div>
          <div class="d-flex gap-2 cbb-map-form__field">
            <div class="cbb-map-form__col">
              <input
                class="cbb-map-form__control disable"
                placeholder="Calle"
                type="text"
                [value]="accessPoint.street"
                readonly />
            </div>
            <div class="cbb-map-form__col">
              <input
                class="cbb-map-form__control disable"
                placeholder="Número"
                type="text"
                [value]="accessPoint.number"
                readonly />
            </div>
          </div>
        </div>

        <button
          *ngIf="enabledSave"
          class="cbb-map-form__btn-continue mt-3"
          [disabled]="isCheckingCoverage"
          (click)="guardar()">
          CONTINUAR
        </button>
    </div>
  </div>
</div>
